import React from "react";
import {Button, TableCell, TableRow, Typography} from "@material-ui/core";
import StatusCardWithoutIcon
    from "../../../../../../../../../shared/components/status-card/status-card-without-icon/StatusCardWithoutIcon";
import TableWithLabels from "../../../../../../../../ui/tables/table-with-labels/TableWithLabels";
import EmptyRow from "../../../../../../../../ui/tables/rows/empty-row/EmptyRow";
import PropTypes from "prop-types";
import {getComparator, stableSort} from "../../../../../../../../../shared/utils/tableUtils";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    cursor: {
        cursor: "auto"
    }
});

const DeviceDetailsTable = (props) => {
    const classes = useStyles();

    const tableContent = props.tableData.length !== 0 ? stableSort(props.tableData, getComparator(props.order)) : []
    const tableRows = (
        tableContent.length !== 0 ? tableContent
            .slice(props.page * props.rowsPerPage, props.page * props.rowsPerPage + props.rowsPerPage)
            .map((cell, idx) => {
                return (
                    <TableRow key={`digital-contract-table-body-${idx}`} className={classes.cursor}>
                        <TableCell component="th" scope="row">
                            <Typography
                                variant="body2">{props.type === "Consegne" ? cell.numero : cell.imei}</Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant="body2">{cell.indirizzoDiConsegna}</Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography
                                variant="body2">{props.type === "Consegne" ? cell.dataOrdine : cell.tipoAssistenza}</Typography>
                        </TableCell>
                        {props.type !== "Consegne" ? null :
                            <>
                                <TableCell align="left">
                                    <StatusCardWithoutIcon text={cell.stato} color="blue"/>
                                </TableCell>
                                <TableCell align="left">
                                    <Button variant='text'
                                            onClick={() => props.handleVediClick(cell.numero)}
                                            color='primary' style={{whiteSpace: 'nowrap'}}>
                                        Vedi Dettagli
                                    </Button>
                                </TableCell>
                            </>

                        }
                    </TableRow>
                )
            }) : <EmptyRow text='dato' colSpan={props.headCells.length + 2}/>
    )

    return <TableWithLabels headCells={props.headCells}
                            tableRows={tableRows}
                            page={props.page}
                            fetchData={props.changeData}
                            rowsPerPage={props.rowsPerPage}
                            count={props.count}
                            loading={props.loading}/>
}

DeviceDetailsTable.propTypes = {
    tableData: PropTypes.array.isRequired,
    headCells: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    changeData: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    handleVediClick: PropTypes.func
}

export default DeviceDetailsTable;